import ProductsInCart from './ProductsInCart';

export default ProductsInCart;
